const fix_url = (url) => {
	if (url.includes('&') && !url.includes('?')) {
		return url.replace('&', '?').replace(/page=\d+/, 'page=0');
	}
	return url.replace(/page=\d+/, 'page=0');
}

const lib_filters = function () {
	const active_filters = Array.from(document.querySelectorAll('[data-root][data-cat="' + window._active_cat_ + '"]'));

	active_filters.forEach(a => {
		a.classList.add('active')
	});

	const filters = Array.from(document.querySelectorAll('.nfilter'));
	const has_sub_filters = !!(document.querySelector('.nsub-filter[data-cat="' + window._active_cat_ + '"]'));

	if (has_sub_filters) {
		filters.forEach(f => {
			if (f.classList.contains('nreturn')) {
				f.style.display = 'block';
			} else if (f.classList.contains('nsub-filter') && f.getAttribute('data-cat') === window._active_cat_) {
				f.style.display = 'block';
			} else if (f.getAttribute('data-cat') !== window._active_cat_) {
				//	f.style.display = 'none';
			}
		});
	};

	if (window._active_sub_cat_) {
		const active_sf = Array.from(document.querySelectorAll('.nsub-filter[data-subcat="' + window._active_sub_cat_ + '"]'));
		active_sf.forEach((a) => {
			a.classList.add('active');
		});
	};

	const all_filters = Array.from(document.querySelectorAll('.nfilter'));

	all_filters.forEach((filter) => {
		if (filter.getAttribute('data-untouched')) return;
		let base = fix_url(window.location.href.replace(/(\?|\&)category=[\w-]+/, '').replace(/\&sub_category=[\w-]+/, ''));
		has_query = base.includes('?');
		const prefix = has_query ? '&' : '?';
		const link = filter.querySelector('a');
		const cat = filter.getAttribute('data-cat');
		if (filter.classList.contains('nsub-filter') && filter.hasAttribute('data-subcat')) {
			const subcat = filter.getAttribute('data-subcat');
			if (filter.classList.contains('active')) {
				link.setAttribute('href', base + prefix + 'category=' + cat);
			} else {
				link.setAttribute('href', base + prefix + 'category=' + cat + '&sub_category=' + subcat);
			}
		} else {
			if (filter.classList.contains('nsub-filter') &&
				filter.getAttribute('data-cat') === window._active_cat_ &&
				!window._active_sub_cat_) {
				filter.classList.add('active');
			}

			if (filter.classList.contains('active')) {
				link.setAttribute('href', base);
			} else {
				link.setAttribute('href', base + prefix + 'category=' + cat);
			}
		} 
		filter.addEventListener('click', (e) => {
			e.preventDefault();
			if (filter.classList.contains('active')) {
				const l = filter.querySelector('a');
				if (l) window.location.href = l.getAttribute('href');
			} else {
				if (filter.hasAttribute('data-shelf')) {
					const p = filter.parentNode;
					if (p && p.classList.contains('shelf')) {
						p.classList.toggle('open');
					}
				} else {
					const l = filter.querySelector('a');
					window.location.href = l.getAttribute('href');
				}
			}
		});
	});
};

lib_filters();

const setup_sorters = () => {
	const sorters = Array.from(document.querySelectorAll('.nfilter-sort'));
	const langs = Array.from(document.querySelectorAll('.nfilter-lang'));

	if (window._active_lang_) {
		const al = langs.find(l => l.getAttribute('data-lang') === window._active_lang_);
		if (!al) return;
		al.classList.add('active');
	}

	if (window._active_sort_) {
		const as = sorters.find(l => l.getAttribute('data-sort') === window._active_sort_ && l.getAttribute('data-sort-by') === window._active_sort_dir_);
		if (!as) return;
		as.classList.add('active');
	}

	sorters.forEach(s => {
		const link = s.querySelector('a');
		let base = fix_url(window.location.href.replace(/(\?|&)sort=\w+&sort_dir=\w+/, ''));
		has_query = base.includes('?');
		const prefix = has_query ? '&' : '?';
		if (!link) return;
		if (s.classList.contains('active')) {
			link.setAttribute('href', base);
		} else {
			link.setAttribute('href', base + prefix + '&sort=' + s.getAttribute('data-sort') + '&sort_dir=' + s.getAttribute('data-sort-by'));
		}
	});

	langs.forEach((l) => {
		const link = l.querySelector('a');
		if (!link) return;
		const base = fix_url(window.location.href.replace(/(\?|&)lang=\w+/, ''));
		has_query = base.includes('?');
		const prefix = has_query ? '&' : '?';
		if (l.classList.contains('active')) {
			link.setAttribute('href', base);
		} else {
			link.setAttribute('href', base + prefix + '&lang=' + l.getAttribute('data-lang'));
		}
	});
};

setup_sorters();

(() => {
	const filters_btn = document.querySelector('#toggle_mobile_filters');
	if (!filters_btn) return;
	const filters_close = document.querySelector('#close_mobile_filters');
	if (!filters_close) return;
	const filters = document.querySelector('.library_n_filters');
	if (!filters) return;
	const backdrop = document.querySelector('.backdrop');
	if (!backdrop) return;
	filters_btn.addEventListener('click', () => {
		filters.classList.add('open');
		filters_close.classList.remove('hidden');
		filters_btn.classList.add('hidden');
		document.body.classList.add('hide_cookies');
		document.body.classList.add('hide_crisp');
	});
	[backdrop, filters_close].forEach(f => f.addEventListener('click', () => {
		filters.classList.remove('open');
		filters_btn.classList.remove('hidden');
		filters_close.classList.add('hidden');
		document.body.classList.remove('hide_cookies');
		document.body.classList.remove('hide_crisp');
	}));
})();